import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import Select from "react-select";

import _ from "../../../i18n";
import { getWebtoolIcons } from "../../../api";
import styles from "./SidebarIcon.module.scss";
import { SELECT_STYLES } from "../../../config";

const statusOptions = [
  { value: "ALL", label: _("all") },
  { value: "USED", label: _("used") },
  { value: "UNUSED", label: _("unused") },
];
const SidebarIcon = (props) => {
  const { isOpened } = props;
  const auth = useSelector((state) => state.auth);
  const language = useSelector((state) => state.params.language);
  const [searchValue, setSearchValue] = useState("");
  const [status, setStatus] = useState(statusOptions[0]);

  let { isLoading, data } = useQuery(
    ["getWebtoolIcons", auth.token, isOpened],
    async () => {
      if (auth.token && isOpened) {
        const response = await getWebtoolIcons(auth.token);

        return response.data.data;
      }
    }
  );

  const titleAttr = `title${
    language.charAt(0).toUpperCase() + language.slice(1)
  }`;

  let filteredItems = [];

  if (!isLoading && data) {
    let filteredData = data;
    if (status.value === "USED") filteredData = data.filter((el) => el.isUsed);
    if (status.value === "UNUSED")
      filteredData = data.filter((el) => !el.isUsed);
    filteredItems = filteredData.filter((item) => {
      return (
        (item[titleAttr] &&
          item[titleAttr].toLowerCase().includes(searchValue.toLowerCase())) ||
        (item.label &&
          item.label.toLowerCase().includes(searchValue.toLowerCase()))
      );
    });
  }

  const selectIcon = (e, item) => {
    props.setIcon(item);
    props.hideSidebar(e);
  };

  return (
    <>
      <div
        className={`${styles.mask} ${isOpened ? "" : styles.hide}`}
        onClick={(e) => props.hideSidebar(e)}
      ></div>
      <div
        className={`${styles.sidebar} ${isOpened && styles.display} ${
          props.className
        }`}
      >
        <div onClick={(e) => props.hideSidebar(e)} className={styles.close}>
          <i className="icon-ttp-close"></i>
        </div>

        <div className={styles.title}>{_("select_icon")}</div>

        {isLoading &&
          [...Array(40).keys()].map((key) => (
            <li
              key={key}
              className="fetching-icons card-item cell small-6 medium-3"
              style={{ backgroundColor: "#eee" }}
            />
          ))}

        {!isLoading && data && (
          <>
            <div className={styles.filters}>
              <div className={styles.search}>
                <input
                  type="text"
                  placeholder={_("search_placeholder")}
                  value={searchValue}
                  onChange={(e) => {
                    setSearchValue(e.target.value);
                  }}
                />
              </div>
              <Select
                styles={SELECT_STYLES}
                options={statusOptions}
                isSearchable={false}
                value={status}
                onChange={(e) => setStatus(e)}
              />
            </div>
            <ul className="grid-x grid-margin-x">
              {filteredItems.map((item) => (
                <li
                  key={item.id}
                  className={`${styles.cardItem} cell small-6 medium-3`}
                  onClick={(e) => selectIcon(e, item)}
                >
                  <i className={`icon webtool-${item.label}`} />
                  <span title={item[titleAttr] || item.label}>
                    {item[titleAttr] || item.label}
                  </span>
                </li>
              ))}
            </ul>
          </>
        )}
      </div>
    </>
  );
};

export default SidebarIcon;
